import React, { useEffect, useState } from "react"
import { enumUtil } from "../../../../utils/Enum"
import NotificationHandler from "../../../../utils/NotificationHandler"
import FormValidator from "../../../../utils/FormValidator"
import handleNumericCheck from "../../../../utils/HandleNumericKeys"
import isNull from "../../../../utils/NullChecking"
import { GetZipCode, ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import Loader from "../../../shared/Loader/Loader"
import States from "../../../../utils/Constants"
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import NpiRegistry from "../../../General/NpiRegistry"
import { Calendar } from 'react-date-range';
import format from 'date-fns/format';
import Audit from "../../../General/Audit"
import SuperSearch from "../../../shared/SuperSearch/SuperSearch"
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList"
import { useSelector } from "react-redux"
import FormatDate from "../../../shared/DateFormatter"
import handleAlphaNumericCheck from "../../../../utils/HandleAlphaNumericKeys"
import ReactInputMask from "react-input-mask"
import FormatPhoneNumber from "../../../../utils/FormatPhoneNumber";
import DropdownValueHandler from "../../../shared/SuperSearch/DropdownValueHandler"
import DatePicker from "../../../General/DatePicker"
import UpdateReduxDropDowns from "../../../shared/UpdateReduxDropDowns"
import { FindSecondChild } from "../../../../utils/FindMenuOption"
import { useKeyboardShortcut } from "../../../../utils/useKeyboardShortcut"
const AddNewPractice = () => {
    const API_URL = enumUtil.controller.General
    let PracticeID = useSelector(state => state.PracticeIDReducer)
    let IsEditAllowed = FindSecondChild('Setup', 'Account', 'Practice')?.IsAdd
    const Practice_Type = [
        { value: '', display: '' },
        { value: 'Solo', display: 'Solo Practice' },
        { value: 'Group', display: 'Group Practice' },
        { value: 'Homecare Agency', display: 'Homecare Agency' },
        { value: 'Adult Day Care', display: 'Adult Day Care' }
    ]
    const Time_Zone = [
        { value: '', display: '' },
        { value: 'PT  ', display: 'Pacific Time (PT)' },
        { value: 'MT', display: 'Mountain Time (MT)' },

        { value: 'CT', display: 'Central Time (CT)' },

        { value: 'ET', display: 'Eastern Time (ET)' },
        { value: 'AKT', display: 'Alaska Time (AKT)' },
        { value: 'HST', display: 'Hawaii Time (HST)' },






        // { value: 'ET', display: 'ET (UTC-5)' },
        // { value: 'PKT', display: 'PKT (UTC+5)' }, // Pakistan Standard Time (UTC+5)
        // { value: 'YEKT', display: 'YEKT (UTC+5)' }, // Yekaterinburg Time (UTC+5)
        // { value: 'UZT', display: 'UZT (UTC+5)' }, // Uzbekistan Time (UTC+5)
        // { value: 'TMT', display: 'TMT (UTC+5)' }, // Turkmenistan Time (UTC+5)
        // { value: 'MVT', display: 'MVT (UTC+5)' }, // Maldives Time (UTC+5)
        // { value: 'EST', display: 'EST (UTC-5)' }, // Eastern Standard Time (UTC-5)
        // { value: 'COT', display: 'COT (UTC-5)' }, // Colombia Time (UTC-5)
        // { value: 'PET', display: 'PET (UTC-5)' }, // Peru Time (UTC-5)
        // { value: 'CST', display: 'CST (UTC-5)' }, // Cuba Standard Time (UTC-5)
    ];
    let Practice_Modal = {
        PracticeCode: "",
        PracticeName: "",
        NPI: "",
        TaxID: "",
        MMISID: "",
        AddressLine1: "",
        AddressLine2: "",
        City: "",
        State: "",
        ZipCode: "",
        ContactPersonName: "",
        ContactPhoneNumber: "",
        EmailAddress: "",
        FaxNumber: "",
        Website: "",
        PaytoAddressLine1: "",
        PaytoAddressLine2: "",
        PaytoCity: "",
        PaytoState: "",
        PaytoZipCode: "",
        PaytoExtendedZipCode: "",
        TimeZoneCode: "",
        GoLiveDate: "",
        PracticeTypes: "",
        TaxonomyCode: "",
        EnteredBy: ""
    }

    let valModal = {}
    // validation modal 
    let ValidationModal = {
        PracticeCodeVal: "",
        PracticeNameVal: "",
        NPILengthVal: "",
        TaxIDLengthVal: "",
        FaxNumberLengthVal: "",
        ZipCodeLengthVal: "",
        EmailAddressVal: "",
        WebsiteVal: "",
        ContactNumberLenghtVal: "",
        ZipCodeDigitVal: "",
    }
    const [mainPracticeModal, setMainPracticeModal] = useState(Practice_Modal);
    const [practiceSaveUpdateModal, setPracticeSaveUpdateModal] = useState({})
    const [practiceValidationModal, setPracticeValidationModal] = useState(ValidationModal)
    const [practiceID, setPracticeID] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [NpiRegistryNumber, setNpiRegistryNumber] = useState();
    const [isOpenRegistry, setIsOpenRegistry] = useState(false);
    const [showCalendar, setShowCalendar] = useState(false);
    const [TimeZoneCode, setTimeZoneCode] = useState({ value: '', display: '' })
    const [TaxonomyCode, setTaxonomyCode] = useState({ Code: '', MedicareSpecialityCode: '' })
    const [isOpenAudit, setisOpenAudit] = useState(false);
    const [TaxonomyDD, setTaxonomyDD] = useState([]);
    const [searchParam, setSearchParam] = useState('')
    const [is, setIs] = useState(false);            // to check weather the api is hit or not (on bases of the api we will filter data for autocomplete or !)
    const [expanded, setExpanded] = React.useState(false);
    const [selectedClassification, setSelectedClassification] = useState('');
    const [errorOnPaste, seterrorOnPaste] = useState(false)
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer)
    const isHomeCareCheck = DropDowns.IsHomeCare
    const handleChangeAccodian = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    // find practice Data by id 
    useEffect(() => {
        setPracticeID(PracticeID);
        if (!isNull(practiceID)) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "ID": practiceID,
                "TableName": enumUtil.enumAPITableName.Practice

            }).then((response) => {
                setIsLoading(false)
                setIs(true)
                response.State = DropdownValueHandler(States, response.State)
                response.PaytoState = DropdownValueHandler(States, response.PaytoState)
                response.TimeZoneCode = DropdownValueHandler(Time_Zone, response.TimeZoneCode)
                Time_Zone.filter((type) => {
                    if (type.value === response.TimeZoneCode) {
                        setTimeZoneCode({ value: type.value, display: type.display })
                    }
                })
                if (!isNull(response.ContactPhoneNumber)) {
                    response.ContactPhoneNumber = FormatPhoneNumber(response.ContactPhoneNumber)
                }
                setMainPracticeModal({ ...response, GoLiveDate: !isNull(response.GoLiveDate) ? FormatDate(response.GoLiveDate) : null })
                setSelectedClassification(response.ClassificationSpecialization);
                // setMainPracticeModal(response)
                // setPracticeID(response.PracticeID)
            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
                setIsLoading(false)
            })
        }
    }, [practiceID])
    const handleTaxonomySearch = (e) => {
        var searchvalue = e.target.value;
        if (e.target.value.length > 1) {
            ServerRequestProtected(API_URL + "/InstantSearch", 'post', {
                "TableName": enumUtil.enumAPITableName.Taxonomy,
                "SearchParam": searchvalue,
            }).then((response) => {
                setIsLoading(false)
                setTaxonomyDD(response)
            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
                setIsLoading(false)
            })
        }
    }
    const handlePracticeChange = (e) => {
        setIs(true)
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }
        let modal = { ...mainPracticeModal };
        let saveModal = { ...practiceSaveUpdateModal }
        if (name === 'ContactPhoneNumber') {
            const formattedValue = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            modal[name] = !formattedValue[2] ? formattedValue[1] : '(' + formattedValue[1] + ') ' + formattedValue[2] + (formattedValue[3] ? '-' + formattedValue[3] : '');
        }
        else if (name === 'ZipCode') {
            GetZipCode(value)
                .then(data => {
                    setMainPracticeModal(prevState => ({ ...prevState, ...data?.main }));
                    setPracticeSaveUpdateModal(prevState => ({ ...prevState, ...data?.save }));
                })
                .catch(error => {
                });
            modal[name] = value;
        }
        else if (name === 'PaytoZipCode') {
            GetZipCode(value)
                .then(data => {
                    modal.PaytoState = data.main.State
                    modal.PaytoCity = data.main.City
                    setMainPracticeModal(prevState => ({ ...prevState, PaytoCity: data.main.City, PaytoState: data.main.State }));
                    saveModal.PayToState = data.save.State
                    saveModal.PaytoCity = data.save.City
                })
                .catch(error => {
                });
            modal[name] = value;
        }
        else {
            modal[name] = value;
        }
        setMainPracticeModal(modal)
        for (var property in Practice_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setPracticeSaveUpdateModal(saveModal)
    }
    const handlePracticeChangeSup = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainPracticeModal };
        modal[name] = value
        setMainPracticeModal(modal)
    }
    const PracticeValidation = async () => {
        let PhoneNumber = '';
        let faxNumber = '';
        if (!isNull(mainPracticeModal.ContactPhoneNumber)) {
            PhoneNumber = mainPracticeModal.ContactPhoneNumber.replace(/[()-\s]/g, "");
        }
        if (!isNull(mainPracticeModal.FaxNumber)) {
            faxNumber = mainPracticeModal.FaxNumber.replace(/-/g, "");
        }
        let ValidationModal = {
            PracticeCodeVal: FormValidator(
                mainPracticeModal.PracticeCode,
                enumUtil.enumValidationType.Required,
                'Practice Code',
            ),
            PracticeNameVal: FormValidator(
                mainPracticeModal.PracticeName,
                enumUtil.enumValidationType.Required,
                'Name',
            ),
            NPILengthVal: FormValidator(
                mainPracticeModal.NPI,
                enumUtil.enumValidationType.Length,
                'NPI',
                10
            ),
            TaxIDLengthVal: FormValidator(
                mainPracticeModal.TaxID,
                enumUtil.enumValidationType.Length,
                'Tax ID',
                9
            ),
            FaxNumberLengthVal: FormValidator(
                faxNumber,
                enumUtil.enumValidationType.Length,
                'Fax Number',
                10
            ),
            ZipCodeLengthVal: FormValidator(
                mainPracticeModal.ZipCode,
                enumUtil.enumValidationType.Lengths,
                'Zip Code',
                5, 9
            ),
            EmailAddressVal: FormValidator(
                mainPracticeModal.EmailAddress,
                enumUtil.enumValidationType.Email,
                'Email',
            ),
            WebsiteVal: FormValidator(
                mainPracticeModal.Website,
                enumUtil.enumValidationType.Website,
                'Website'
            ),
            ContactNumberLenghtVal: FormValidator(
                PhoneNumber,
                enumUtil.enumValidationType.Length,
                'Contact Number',
                10
            ),
            ZipCodeDigitVal: FormValidator(
                mainPracticeModal.ZipCode,
                enumUtil.enumValidationType.Digit,
                'Zip Code',
            ),
        }
        await setPracticeValidationModal(ValidationModal)
        valModal = ValidationModal

    }
    const handleSavePractice = async () => {
        await PracticeValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            // practiceSaveUpdateModal['PracticeID'] = practiceID;
            if (practiceSaveUpdateModal.FaxNumber != null) {
                practiceSaveUpdateModal['FaxNumber'] = practiceSaveUpdateModal.FaxNumber.replace(/-/g, "");
            }
            if (practiceSaveUpdateModal.ContactPhoneNumber != null) {
                practiceSaveUpdateModal['ContactPhoneNumber'] = practiceSaveUpdateModal.ContactPhoneNumber.replace(/[()-\s]/g, "");
                practiceSaveUpdateModal.ContactPhoneNumber = practiceSaveUpdateModal.ContactPhoneNumber.slice(0, 10);
            }
            let saveModal = {
                TableName: enumUtil.enumAPITableName.Practice,
                ID: practiceID,
                data: { ...practiceSaveUpdateModal },
                value: null
            }
            // setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal).then((response) => {
                if (!isNull(response.id)) {
                    UpdateReduxDropDowns(practiceID, DropDowns.UserPractices, response.id, mainPracticeModal.PracticeName)
                    setIsLoading(false)
                    NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                    setPracticeID(response.id)
                }
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            })
        }
    }
    const handleNpiRegistry = () => {
        if (mainPracticeModal.NPI != undefined) {
            setNpiRegistryNumber(mainPracticeModal.NPI)
        }
        setIsOpenRegistry(true);
        setIsLoading(false);

    }
    const CloseRegistry = (data) => {
        setIsOpenRegistry(false)
        setIs(true)
        if (data === NpiRegistryNumber) {
            setNpiRegistryNumber(data)
        }
        mainPracticeModal.PracticeName = data.OrganizationName
        mainPracticeModal.AddressLine1 = data.AddressLine1
        mainPracticeModal.AddressLine2 = data.AddressLine2
        mainPracticeModal.City = data.City
        mainPracticeModal.State = DropdownValueHandler(States, data.State)
        mainPracticeModal.PaytoState = DropdownValueHandler(States, data.PayToState)
        // mainPracticeModal.State = data.State
        mainPracticeModal.ZipCode = data.ZipCode
        const FormatedContcatNumber = !isNull(data.ContactPhoneNumber) ? FormatPhoneNumber(data.ContactPhoneNumber) : ''
        mainPracticeModal.ContactPhoneNumber = FormatedContcatNumber
        mainPracticeModal.PaytoAddressLine1 = data.PayToAddressLine1
        mainPracticeModal.PaytoAddressLine2 = data.PayToAddressLine2
        mainPracticeModal.PaytoCity = data.PayToCity
        // mainPracticeModal. = data.PayToState
        mainPracticeModal.PaytoZipCode = data.PayToZipCode
        mainPracticeModal.NPI = data.NPI
        mainPracticeModal.FaxNumber = data.FaxNumber
        mainPracticeModal.PracticeTypes = !isNull(data.NPIType) ? data.NPIType === 'NPI-1' ? 'Solo Practice' : 'Group Practice' : mainPracticeModal.PracticeTypes
        mainPracticeModal.ContactPersonName = !isNull(data.ContactPersonName) ? data.ContactPersonName : mainPracticeModal.ContactPersonName

        mainPracticeModal.TaxonomyCode = data.TaxonomyCode
        //SaveUpdateModal
        practiceSaveUpdateModal.PracticeName = data.OrganizationName
        practiceSaveUpdateModal.AddressLine1 = data.AddressLine1
        practiceSaveUpdateModal.AddressLine2 = data.AddressLine2
        practiceSaveUpdateModal.City = data.City
        practiceSaveUpdateModal.State = data.State
        practiceSaveUpdateModal.ZipCode = data.ZipCode
        practiceSaveUpdateModal.ContactPhoneNumber = FormatedContcatNumber
        practiceSaveUpdateModal.PaytoAddressLine1 = data.PaytoAddressLine1
        practiceSaveUpdateModal.PaytoAddressLine2 = data.PaytoAddressLine2
        practiceSaveUpdateModal.PaytoCity = data.PaytoCity
        practiceSaveUpdateModal.PaytoZipCode = data.PaytoZipCodeC
        practiceSaveUpdateModal.NPI = data.NPI
        practiceSaveUpdateModal.TaxonomyCode = data.TaxonomyCode
        practiceSaveUpdateModal.FaxNumber = data.FaxNumber
        practiceSaveUpdateModal.ContactPersonName = !isNull(data.ContactPersonName) ? data.ContactPersonName : ''
        practiceSaveUpdateModal.PracticeTypes = !isNull(data.NPIType) ? data.NPIType === 'NPI-1' ? 'Solo' : 'Group' : practiceSaveUpdateModal.PracticeTypes

    }
    const onCloseNpi = () => {
        setIsOpenRegistry(false)
    }
    let PopupScreen = "";
    if (isOpenRegistry) {
        PopupScreen = <NpiRegistry isOpenRegistry={isOpenRegistry} NpiNumber={NpiRegistryNumber} onClosee={CloseRegistry} onCloseNpi={onCloseNpi} ClassName='npi-panel npi-open npi_detail_popup practice_npi_detail' />
    }
    const handleCalendarChange = (date, type) => {
        var FormatedDate = date
        let modal = { ...mainPracticeModal };
        let saveModal = { ...practiceSaveUpdateModal }
        modal[type] = FormatedDate
        setMainPracticeModal(modal)
        for (var property in Practice_Modal) {
            if (type === property) {
                saveModal[type] = FormatedDate
            }
        }
        setPracticeSaveUpdateModal(saveModal)
    }
    const handleAuditModal = () => {
        setisOpenAudit(true)
    }
    const onCloseAudit = () => {
        setisOpenAudit(false)
    }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={practiceID + ""} TableName={enumUtil.enumAPITableName.Practice} />
    }
    const handleSelectedData = (selectedData, name, type) => {
        let modal = { ...mainPracticeModal };
        if (type === 'client' && !isNull(selectedData)) {
            if (name === 'State') {
                modal[name] = selectedData.display
                practiceSaveUpdateModal[name] = selectedData.value;
            }
            else if (name === 'TimeZoneCode') {
                modal[name] = selectedData.display
                practiceSaveUpdateModal[name] = selectedData.value;
            }
            else if (name === 'PaytoState') {
                modal[name] = selectedData.display
                practiceSaveUpdateModal[name] = selectedData.value;
            }
            else if (name === 'PracticeTypes') {
                modal[name] = selectedData.display
                practiceSaveUpdateModal[name] = selectedData.display;
            }
            else if (name === 'TaxonomyCode') {
                modal[name] = selectedData.display
                practiceSaveUpdateModal[name] = selectedData.value;
            }

        } else if (type === 'server' && !isNull(selectedData)) {
            if (name === 'POSCode') {
                // practiceSaveUpdateModal[name] = selectedData.ID
                // setSearchValue(selectedData.ID)
            }
        } else {
            modal[name] = ''
            practiceSaveUpdateModal[name] = ''
        }
        setMainPracticeModal(modal)

        return selectedData
    };
    ///////Super Search////////
    const getTaxonomyCodeSelected = (selectedData, name, type) => {
        if (!isNull(selectedData)) {
            if (type === 'client') {
                if (name === 'State') {
                }
            } else if (type === 'server') {
                if (name === 'TaxonomyCode') {
                    setMainPracticeModal({ ...mainPracticeModal, TaxonomyCode: selectedData.Code })
                    practiceSaveUpdateModal['TaxonomyCode'] = selectedData.Code
                    setSelectedClassification(selectedData.ClassificationSpecialization);
                }
            }
        } else {
            if (name === "TaxonomyCode") {
                setMainPracticeModal({ ...mainPracticeModal, TaxonomyCode: '' })
                practiceSaveUpdateModal['TaxonomyCode'] = ''
                setSelectedClassification('');
            }
        }
        return selectedData
    }
    ///////////////
    let SidebarActive = useSelector(state => state.SidebarActiveTab);

    const SetupTabsData = useSelector(state => state.SetupActiveTabReducer);
    const activeTabData = SetupTabsData.find(tab => tab.active && tab.key === 61);
    const activeSubMenu = activeTabData?.subMenu?.find(subItem => subItem.active);
    const enabled = activeSubMenu?.key === 611 && SidebarActive === 5;
    useKeyboardShortcut("s+c", handleSavePractice, 300, enabled);

    return (
        <React.Fragment>
            {isLoading ? <Loader /> : null}
            {PopupScreen}
            <div className="hk-lt-popper col-md-4 br-clr br-right-1">
                {AuditPopup}
            </div>
            <div className='tabs-container  d-flex flex-column justify-content-between addnew_prac'>
                <div className="row g-0  flex-1 addnew_practice">
                    <div className="col-md-4 br-clr br-right-1 position-relative">
                        <div className="position-absolute end-0 mt-1 pe-3">
                            <button aria-describedby={Boolean(isOpenAudit) ? 'simple-popper' : undefined} type="button" className='btn-icon-transparent' onClick={handleAuditModal}>
                                <div className="app_tooltip left">
                                    <span className="icon-menu-1"><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span><span className="path9"></span><span className="path10"></span></span>
                                    <p className="tool_tip xsm_text text-light">Audit</p>
                                </div>
                            </button>
                        </div>
                        <div className="p-3">
                            <div className=" form-group input m-0">
                                <label htmlFor="">Short Name
                                    <span className='req'>*</span>
                                    {/* <button className='btn-icon-transparent me-1' onClick={handleAuditModal}><i className="bi bi-trash-fill"></i></button> */}
                                </label>
                                <div className={practiceValidationModal.PracticeCodeVal ? 'form-group input error' : 'form-group input m-0'}>
                                    <input
                                        type="text"
                                        maxLength={10}
                                        className="form-control"
                                        name="PracticeCode"
                                        id="PracticeCode"
                                        autoComplete="off"
                                        value={mainPracticeModal.PracticeCode}
                                        onChange={handlePracticeChange}
                                        onKeyPress={(event) => handleAlphaNumericCheck(event)} />
                                    {practiceValidationModal.PracticeCodeVal}
                                </div>
                                {/* error helperText="Error Message" */}
                            </div>
                            <div className="form-group input m-0">
                                <label htmlFor="" className="mt-2">Practice Name <span className='req'>*</span></label>
                                <div className={practiceValidationModal.PracticeNameVal ? 'form-group input error' : 'form-group input m-0'}>
                                    <input variant="outlined"
                                        type="text"
                                        maxLength={80}
                                        className="form-control"
                                        name="PracticeName"
                                        id="PracticeName"
                                        autoComplete="off"
                                        value={mainPracticeModal.PracticeName}
                                        onChange={handlePracticeChange} />
                                </div>
                                {practiceValidationModal.PracticeNameVal}
                            </div>
                            <div className='form-group input m-0'>
                                <label htmlFor="" className="mt-2">Practice Type</label>
                                <SuperSearchList
                                    type="client"
                                    id='PracticeTypes'
                                    name='PracticeTypes'
                                    searchValue={mainPracticeModal.PracticeTypes}
                                    data={Practice_Type}
                                    onChange={handlePracticeChangeSup}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    sup_btn='sup_btn-Inp'
                                    sup_inp='superSearchVisitInp'
                                    isReadOnly={true}
                                // filterWith="startsWith"
                                // tableHeight="200px"
                                // tableWidth="100%"
                                />

                            </div>
                            <div className={practiceValidationModal.NPILengthVal ? 'form-group input error' : 'form-group input m-0'}>
                                <label htmlFor="" className="mt-2">NPI</label>
                                <div className='field-icon'>
                                    <input variant="outlined"
                                        type="text"
                                        maxLength={10}
                                        className="form-control"
                                        name="NPI"
                                        id="NPI"
                                        autoComplete="off"
                                        value={mainPracticeModal.NPI}
                                        onChange={handlePracticeChange}
                                        onKeyPress={(event) => handleNumericCheck(event)}
                                    />
                                    {practiceValidationModal.NPILengthVal}
                                    <div className='last'>
                                        <div className="app_tooltip left" onClick={handleNpiRegistry}>
                                            <div className='NPI-R-circle'>R</div>
                                            <p className="tool_tip xsm_text text-light">NPI Registry</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={practiceValidationModal.TaxIDLengthVal ? 'form-group input error' : 'form-group input m-0'}>
                                <label htmlFor="" className="mt-2">Tax ID </label>
                                <input variant="outlined"
                                    type="text"
                                    className="form-control"
                                    name="TaxID"
                                    id="TaxID"
                                    autoComplete="off"
                                    maxLength={9}
                                    value={mainPracticeModal.TaxID}
                                    onChange={handlePracticeChange}
                                    onKeyPress={(event) => handleNumericCheck(event)}
                                />
                                {practiceValidationModal.TaxIDLengthVal}
                            </div>
                            <div className='form-group input'>
                                <label htmlFor="" className="mt-2">Taxonomy Code</label>

                                <SuperSearch
                                    ApiLink={API_URL + "/InstantSearch"}
                                    method="post"
                                    postBody={{
                                        "TableName": enumUtil.enumAPITableName.Taxonomy,
                                        "SearchParam": mainPracticeModal.TaxonomyCode,
                                    }}
                                    // tableHeight={400}
                                    // tableWidth="400px"
                                    id={'TaxonomyCode'}
                                    getSelectedData={(value) => getTaxonomyCodeSelected(value, "TaxonomyCode", "server")}
                                    onChange={(e) => setMainPracticeModal({ ...mainPracticeModal, TaxonomyCode: e.target.value })}
                                    searchValue={mainPracticeModal.TaxonomyCode}
                                    tableData={[
                                        // { columName: 'ID', bindingValue: 'TaxonomyID', },
                                        { columName: 'Code', bindingValue: 'Code', },
                                        { columName: 'Classification Specialization', bindingValue: 'ClassificationSpecialization', },
                                    ]}
                                    disabled={false}
                                    sup_btn='sup_btn-Inp'
                                    sup_inp='superSearchVisitInp'
                                />
                            </div>
                            <div className="form-group input yellow-box">
                                <p className="mb-0">{selectedClassification} </p>
                            </div>
                            {isHomeCareCheck === "true" && (
                                <div className='form-group input m-0'>
                                    <label htmlFor="" className="mt-2">MMIS</label>
                                    <input variant="outlined"
                                        type="text"
                                        className="form-control"
                                        name="MMISID"
                                        id="MMISID"
                                        autoComplete="off"
                                        maxLength={9}
                                        value={mainPracticeModal.MMISID}
                                        onChange={handlePracticeChange}
                                        onKeyPress={(event) => handleNumericCheck(event)}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="app-accordian">
                            <Accordion defaultExpanded>
                                <AccordionSummary
                                    aria-hidden='true'
                                    id="prac1-header"
                                    aria-controls="prac1-content"
                                    expandIcon={<ExpandMoreIcon />}
                                >
                                    <p className="heading">Address Information</p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className='row  row-half'>
                                        <div className="col-md-6">
                                            <div className='input'>
                                                <label htmlFor="">Address Line 1</label>
                                                <input variant="outlined"
                                                    className="form-control"
                                                    name="AddressLine1"
                                                    id="AddressLine1"
                                                    autoComplete="off"
                                                    maxLength={55}
                                                    value={mainPracticeModal.AddressLine1}
                                                    onChange={handlePracticeChange} />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className='input'>
                                                <label htmlFor="">Address Line 2</label>
                                                <input variant="outlined"
                                                    className="form-control"
                                                    name="AddressLine2"
                                                    id="AddressLine2"
                                                    autoComplete="off"
                                                    maxLength={55}
                                                    value={mainPracticeModal.AddressLine2}
                                                    onChange={handlePracticeChange} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row row-gap-15 row-half mt-2'>
                                        <div className="col-md-3">
                                            <div className='input'>
                                                <label htmlFor="">City</label>
                                                <input variant="outlined"
                                                    type="text"
                                                    maxLength={30}
                                                    className="form-control"
                                                    name="City"
                                                    id="City"
                                                    autoComplete="off"
                                                    value={mainPracticeModal.City}
                                                    onChange={handlePracticeChange} />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className='input'>
                                                {/* <label htmlFor="">State</label>
                                                            <Autocomplete
                                                            id="State"
                                                            disableClearable={true}
                                                            value={statesValue}
                                                            options={States}
                                                            onChange={(event, value) =>   handleDropDownChange(value, 'State')}
                                                            getOptionLabel={(option) => option.display}
                                                            noOptionsText={"Not Available"}
                                                            renderInput={(params) => <TextField {...params}  variant="standard"/>}
                                                        /> */}
                                                <label htmlFor="">State</label>
                                                <SuperSearchList
                                                    type="client"
                                                    id='State'
                                                    name='State'
                                                    searchValue={mainPracticeModal.State}
                                                    data={States}
                                                    onChange={handlePracticeChangeSup}
                                                    getSelectedData={handleSelectedData}
                                                    is={is}
                                                    sup_btn='sup_btn-Inp'
                                                    sup_inp='superSearchVisitInp'
                                                // filterWith="startsWith"
                                                // tableHeight="200px"
                                                // tableWidth="100%"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group input">
                                                <label htmlFor="">Zip Code</label>
                                                <div className={practiceValidationModal.ZipCodeLengthVal || practiceValidationModal.ZipCodeDigitVal ? 'input error' : 'input'}>
                                                    <input variant="outlined"
                                                        type="text"
                                                        className="form-control"
                                                        maxLength={9}
                                                        name="ZipCode"
                                                        id="ZipCode"
                                                        autoComplete="off"
                                                        value={mainPracticeModal.ZipCode}
                                                        onChange={handlePracticeChange}
                                                        onKeyPress={(event) => handleNumericCheck(event)}
                                                    />
                                                    {practiceValidationModal.ZipCodeLengthVal || practiceValidationModal.ZipCodeDigitVal}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion defaultExpanded>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    id="prac2-header"
                                    aria-controls="prac2-content"
                                >
                                    <p className="heading">Contact Information</p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className='row row-half'>
                                        <div className="col-md-3">
                                            <div className='input'>
                                                <label htmlFor="">Name</label>
                                                <input variant="outlined"
                                                    type="text"
                                                    maxLength={35}
                                                    className="form-control"
                                                    name="ContactPersonName"
                                                    id="ContactPersonName"
                                                    autoComplete="off"
                                                    value={mainPracticeModal.ContactPersonName}
                                                    onChange={handlePracticeChange} />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group input m-0">
                                                <label htmlFor="">Contact Number</label>
                                                <div className={practiceValidationModal.ContactNumberLenghtVal ? 'form-group input error' : 'form-group input m-0'}>  <input
                                                    type="text"
                                                    className='form-control'
                                                    placeholder="(555) 555-5555"
                                                    name="ContactPhoneNumber"
                                                    id="ContactPhoneNumber"
                                                    autoComplete="off"
                                                    value={mainPracticeModal.ContactPhoneNumber}
                                                    onChange={handlePracticeChange}
                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                />
                                                    {practiceValidationModal.ContactNumberLenghtVal}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group input m-0">
                                                <label htmlFor="">Email Address</label>
                                                <div className={practiceValidationModal.EmailAddressVal ? 'input error' : 'input'}>
                                                    <input type="email"
                                                        maxLength={50}
                                                        className='form-control'
                                                        name="EmailAddress"
                                                        id="EmailAddress"
                                                        autoComplete="off"
                                                        value={mainPracticeModal.EmailAddress}
                                                        onChange={handlePracticeChange}
                                                    />
                                                </div>
                                            </div>
                                            {practiceValidationModal.EmailAddressVal}
                                        </div>
                                        <div className="col-md-6 mt-2">
                                            <div className="form-group input m-0">
                                                <label htmlFor="">Website</label>
                                                <div className={practiceValidationModal.WebsiteVal ? 'form-group input error' : 'form-group input'}>
                                                    <input type="text"
                                                        className='form-control'
                                                        maxLength={200}
                                                        name="Website"
                                                        id="Website"
                                                        autoComplete="off"
                                                        value={mainPracticeModal.Website}
                                                        onChange={handlePracticeChange}
                                                    />
                                                    {practiceValidationModal.WebsiteVal}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3 mt-2">
                                            <div className="form-group input m-0">
                                                <label htmlFor="">Fax Number</label>
                                                <div className={practiceValidationModal.FaxNumberLengthVal ? 'form-group input error' : 'form-group input'}>
                                                    <ReactInputMask type="text"
                                                        maskChar={0}
                                                        mask='999-999-9999'
                                                        className='form-control'
                                                        name="FaxNumber"
                                                        id="FaxNumber"
                                                        autoComplete="off"
                                                        value={mainPracticeModal.FaxNumber}
                                                        onChange={handlePracticeChange}
                                                        onKeyPress={(event) => handleNumericCheck(event)}
                                                    />
                                                    {practiceValidationModal.FaxNumberLengthVal}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion expanded={expanded === 'prac3-header'} onChange={handleChangeAccodian('prac3-header')}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    id="prac3-header"
                                    aria-controls="prac3-content"
                                >
                                    <p className="heading">Pay to Address Information</p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className='row row-half'>
                                        <div className="col-md-6">
                                            <div className='input'>
                                                <label htmlFor="">Address Line 1</label>
                                                <input variant="outlined"
                                                    className="form-control"
                                                    name="PaytoAddressLine1"
                                                    id="PaytoAddressLine1"
                                                    autoComplete="off"
                                                    maxLength={55}
                                                    value={mainPracticeModal.PaytoAddressLine1}
                                                    onChange={handlePracticeChange} />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className='input'>
                                                <label htmlFor="">Address Line 2</label>
                                                <input variant="outlined"
                                                    className="form-control"
                                                    name="PaytoAddressLine2"
                                                    id="PaytoAddressLine2"
                                                    autoComplete="off"
                                                    maxLength={55}
                                                    value={mainPracticeModal.PaytoAddressLine2}
                                                    onChange={handlePracticeChange} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row row-gap-15 row-half mt-2'>
                                        <div className="col-md-3">
                                            <div className='input'>
                                                <label htmlFor="">City</label>
                                                <input variant="outlined"
                                                    type="text"
                                                    className="form-control"
                                                    maxLength={30}
                                                    name="PaytoCity"
                                                    id="PaytoCity"
                                                    autoComplete="off"
                                                    value={mainPracticeModal.PaytoCity}
                                                    onChange={handlePracticeChange} />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className='input'>
                                                <label htmlFor="">State</label>
                                                <SuperSearchList
                                                    type="client"
                                                    id='PaytoState'
                                                    name='PaytoState'
                                                    searchValue={mainPracticeModal.PaytoState}
                                                    data={States}
                                                    onChange={handlePracticeChangeSup}
                                                    getSelectedData={handleSelectedData}
                                                    is={is}
                                                    sup_btn='sup_btn-Inp'
                                                    sup_inp='superSearchVisitInp'
                                                // filterWith="startsWith"
                                                // tableHeight="200px"
                                                // tableWidth="100%"
                                                />
                                                {/* <Autocomplete
                                                    id="PaytoState"
                                                    disableClearable={true}
                                                    value={PaytoStateValue}
                                                    options={States}
                                                    onChange={(event, value) => handleDropDownChange(value, 'PaytoState')}
                                                    getOptionLabel={(option) => option.display}
                                                    noOptionsText={"Not Available"}
                                                    renderInput={(params) => <TextField {...params} variant="standard" />}
                                                /> */}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="from-group input">
                                                <label htmlFor="">Zip Code</label>
                                                <div className={practiceValidationModal.ZipCodeLengthVal || practiceValidationModal.ZipCodeDigitVal ? 'input error' : 'input'}>
                                                    <input variant="outlined"
                                                        type="text"
                                                        maxLength={9}
                                                        className="form-control"
                                                        name="PaytoZipCode"
                                                        id="PaytoZipCode"
                                                        autoComplete="off"
                                                        value={mainPracticeModal.PaytoZipCode}
                                                        onChange={handlePracticeChange}
                                                        onKeyPress={(event) => handleNumericCheck(event)}
                                                    />
                                                    {practiceValidationModal.ZipCodeLengthVal || practiceValidationModal.ZipCodeDigitVal}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion expanded={expanded === 'prac4-header'} onChange={handleChangeAccodian('prac4-header')}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    id="prac4-header"
                                    aria-controls="prac4-content"
                                >
                                    <p className="heading">Other Information</p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className='row row-half'>
                                        <div className="col-md-4">
                                            <div className='input mb-3'>
                                                <label htmlFor="">Time Zone Code</label>
                                                <SuperSearchList
                                                    type="client"
                                                    id='TimeZoneCode'
                                                    name='TimeZoneCode'
                                                    searchValue={mainPracticeModal.TimeZoneCode}
                                                    data={Time_Zone}
                                                    onChange={handlePracticeChangeSup}
                                                    getSelectedData={handleSelectedData}
                                                    is={is}
                                                    sup_btn='sup_btn-Inp'
                                                    sup_inp='superSearchVisitInp'
                                                // filterWith="startsWith"
                                                // tableHeight="200px"
                                                // tableWidth="100%"
                                                />
                                                {/* <Autocomplete
                                                    id="State"
                                                    disableClearable={true}
                                                    value={TimeZoneCode}
                                                    options={Time_Zone}
                                                    onChange={(event, value) => handleDropDownChange(value, 'TimeZoneCode')}
                                                    getOptionLabel={(option) => option.display}
                                                    noOptionsText={"Not Available"}
                                                    renderInput={(params) => <TextField {...params} variant="standard" />}
                                                /> */}
                                                {/* <Select
                                                        className='app-mui-select'
                                                        name="TimeZoneCode"
                                                        id="TimeZoneCode"
                                                        value={mainPracticeModal.TimeZoneCode}
                                                        onChange={handlePracticeChange}
                                                        variant="outlined"
                                                        displayEmpty
                                                        inputProps={{ 'aria-label': 'Without label' }}
                                                    >
                                                        {Time_Zone.map((type) => {
                                                            return (
                                                                <MenuItem value={type.value} key={type.value}>{type.display}</MenuItem>
                                                            )
                                                        })}
                                                    </Select> */}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <DatePicker
                                                label='Go Live Date'
                                                value={mainPracticeModal.GoLiveDate}
                                                handleCalendarChangefunc={date => handleCalendarChange(date, 'GoLiveDate')}
                                            />
                                        </div>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    </div>

                </div>
                <div className='tabs-action-bottom'>
                    <div className='btns-group text-end px-3 py-2 br-top-1 br-bottom-1 br-clr d-flex align-items-center justify-content-between '>
                        <div >
                            {mainPracticeModal.UpdatedDate ?
                                <p className='heading heading_ext'>Updated By/Date: <span className='text text_color'>{mainPracticeModal.UpdatedBy}, {mainPracticeModal.UpdatedDate}</span></p>
                                : null}

                        </div>
                        <div>
                            <button className='btn btn-gray me-2'>Cancel</button>
                            <button className={IsEditAllowed ? 'btn btn-orange ' : 'btn btn-orange  disabled'} onClick={handleSavePractice}>Save</button>
                        </div>
                    </div>
                </div>

            </div>

        </React.Fragment>

    )
}

export default AddNewPractice